/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreatePlanForDoka360ProjectCommandParam } from '../models/create-plan-for-doka-360-project-command-param';
import { Doka360ProjectModel } from '../models/doka-360-project-model';
import { PlansModel } from '../models/plans-model';
import { UpdatePlanForDoka360ProjectCommandParam } from '../models/update-plan-for-doka-360-project-command-param';

@Injectable({ providedIn: 'root' })
export class Doka360ProjectsApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDoka360ProjectById()` */
  static readonly GetDoka360ProjectByIdPath = '/api/v1/doka360projects/{doka360ProjectsUid}';

  /**
   * Get a Doka360Project by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDoka360ProjectById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getDoka360ProjectById$Plain$Response(
    params: {
      doka360ProjectsUid: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Doka360ProjectModel>> {
    const rb = new RequestBuilder(this.rootUrl, Doka360ProjectsApiClient.GetDoka360ProjectByIdPath, 'get');
    if (params) {
      rb.path('doka360ProjectsUid', params.doka360ProjectsUid, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Doka360ProjectModel>;
      })
    );
  }

  /**
   * Get a Doka360Project by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDoka360ProjectById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getDoka360ProjectById$Plain(
    params: {
      doka360ProjectsUid: string;
    },
    context?: HttpContext
  ): Observable<Doka360ProjectModel> {
    return this.getDoka360ProjectById$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Doka360ProjectModel>): Doka360ProjectModel => r.body)
    );
  }

  /**
   * Get a Doka360Project by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDoka360ProjectById()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getDoka360ProjectById$Response(
    params: {
      doka360ProjectsUid: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Doka360ProjectModel>> {
    const rb = new RequestBuilder(this.rootUrl, Doka360ProjectsApiClient.GetDoka360ProjectByIdPath, 'get');
    if (params) {
      rb.path('doka360ProjectsUid', params.doka360ProjectsUid, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Doka360ProjectModel>;
      })
    );
  }

  /**
   * Get a Doka360Project by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDoka360ProjectById$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getDoka360ProjectById(
    params: {
      doka360ProjectsUid: string;
    },
    context?: HttpContext
  ): Observable<Doka360ProjectModel> {
    return this.getDoka360ProjectById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Doka360ProjectModel>): Doka360ProjectModel => r.body)
    );
  }

  /** Path part for operation `createPlanForDoka360Project()` */
  static readonly CreatePlanForDoka360ProjectPath = '/api/v1/doka360projects/{doka360ProjectsUid}/plans';

  /**
   * Create plan for Doka360Project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanForDoka360Project$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  createPlanForDoka360Project$Plain$Response(
    params: {
      doka360ProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, Doka360ProjectsApiClient.CreatePlanForDoka360ProjectPath, 'post');
    if (params) {
      rb.path('doka360ProjectsUid', params.doka360ProjectsUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Create plan for Doka360Project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanForDoka360Project$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  createPlanForDoka360Project$Plain(
    params: {
      doka360ProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.createPlanForDoka360Project$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

  /**
   * Create plan for Doka360Project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanForDoka360Project()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  createPlanForDoka360Project$Response(
    params: {
      doka360ProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, Doka360ProjectsApiClient.CreatePlanForDoka360ProjectPath, 'post');
    if (params) {
      rb.path('doka360ProjectsUid', params.doka360ProjectsUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Create plan for Doka360Project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanForDoka360Project$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  createPlanForDoka360Project(
    params: {
      doka360ProjectsUid: string;
      body: CreatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.createPlanForDoka360Project$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

  /** Path part for operation `updatePlanForDoka360Project()` */
  static readonly UpdatePlanForDoka360ProjectPath = '/api/v1/doka360projects/{doka360ProjectsUid}/plans/{engHubPlanUid}';

  /**
   * Update plan for Doka360Project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlanForDoka360Project$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  updatePlanForDoka360Project$Plain$Response(
    params: {
      doka360ProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, Doka360ProjectsApiClient.UpdatePlanForDoka360ProjectPath, 'patch');
    if (params) {
      rb.path('doka360ProjectsUid', params.doka360ProjectsUid, {});
      rb.path('engHubPlanUid', params.engHubPlanUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Update plan for Doka360Project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlanForDoka360Project$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  updatePlanForDoka360Project$Plain(
    params: {
      doka360ProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.updatePlanForDoka360Project$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

  /**
   * Update plan for Doka360Project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlanForDoka360Project()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  updatePlanForDoka360Project$Response(
    params: {
      doka360ProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlansModel>> {
    const rb = new RequestBuilder(this.rootUrl, Doka360ProjectsApiClient.UpdatePlanForDoka360ProjectPath, 'patch');
    if (params) {
      rb.path('doka360ProjectsUid', params.doka360ProjectsUid, {});
      rb.path('engHubPlanUid', params.engHubPlanUid, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlansModel>;
      })
    );
  }

  /**
   * Update plan for Doka360Project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlanForDoka360Project$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  updatePlanForDoka360Project(
    params: {
      doka360ProjectsUid: string;
      engHubPlanUid: string;
      body: UpdatePlanForDoka360ProjectCommandParam
    },
    context?: HttpContext
  ): Observable<PlansModel> {
    return this.updatePlanForDoka360Project$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlansModel>): PlansModel => r.body)
    );
  }

}
